export default {
    top_menu: [
        {name:'Башкы нерсе',    id:0},
        {name:'Көрсөтүү-Biznes', id:1},
        {name:'Cooking',  id:2},
        {name:'Саясат',   id:3},
        {name:'Ачуу',  id:4},
        {name:'Коом',   id:5},
        {name:'Ден соолук',   id:6},
    ],
    read_other: 'Көбүрөөк окуу',
    read_more:  'Көбүрөөк окуу',
    not_found:  'Эч нерсе табылган жок',
    read_also:  'Ошондой эле окуңуз',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Бардык укуктар корголгон.',
    subscribe: 'Жазылуу',

    thank_order: 'ЗАКАЗЫҢЫЗ ҮЧҮН РАХМАТ',
    specialist_contact: 'Биздин адис жакында сиз менен байланышат, чалуубузду күтө туруңуз.',
    attention: 'Өнөктөштөрдөн арзандатуулар:',
    hurry: 'Шашылыңыз, арзандатууну кошуу убактысы чектелген! Бул уникалдуу продуктулардын бирин тандоого болгону <span id="time" class="time">30:00</span> мүнөт убакыт бар:',

    hour_ago1: "бир саат мурун",
    hour_ago2: "саат мурун",
    hour_ago3: "саат мурун",
    new_publications: "Жаңы басылмалар",
    read: "Оку",
    today_at: "Бүгүн саат",
    author_names: ['Саламат Садыкова','Гүлнур Сатылганова','Жийдеш Идирисова'],
    main_news: "Негизги кабар",
    leave_already: "Уже кетип жатасынбы? Күтө туруңуз, биз сиз үчүн жаңылыктарды жаңырттык",
    already_shared: "мурунтан эле бөлүшүлгөн"

}